export default __webpack_public_path__ + "static/media/MondayRingRing.a37eb0f6.png";